<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle" tutorial="contactos"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <ng-template #factuoneCell let-row="row">
      <div class="status-indicator">
        <span
          class="status-dot"
          [class.status-dot-active]="row.inConvfact"
          [class.status-dot-inactive]="!row.inConvfact">
        </span>
      </div>
    </ng-template>

    <ng-template #directCell let-row="row">
      <div class="status-indicator">
        <span
          class="status-dot"
          [class.status-dot-active]="row.isDirect"
          [class.status-dot-inactive]="!row.isDirect">
        </span>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-contact-detail-tabs [row]="row"></app-contact-detail-tabs>
    </ng-template>
  </div>
</div>
